import {createSelector} from 'reselect';
import {getKlarnaCustomerDetails} from './PaymentOptionSelectors/Klarna/KlarnaSelectors';
import {getSelectedPudoAddress} from './PudoSelectors';

export const getPudoAddressDetailsInKlarnaSDKFormat = createSelector(
  [getSelectedPudoAddress, getKlarnaCustomerDetails],
  (pudoAddress, customerDetails) => {
    if (!pudoAddress) return;
    
    return {
      city: pudoAddress.line3,
      country: pudoAddress.countryCode,
      email: customerDetails.email,
      family_name: customerDetails.lastName,
      given_name: customerDetails.firstName,
      phone: pudoAddress.phoneNumber,
      postal_code: pudoAddress.postcode,
      region: pudoAddress.line4,
      street_address: `${pudoAddress.buildingNameNumber}, ${pudoAddress.line1}`,
      street_address2: pudoAddress.line2,
    };
  },
);

export const getPudoAddressDetailsInKlarnaSDKAttachmentFormat = createSelector(
  [getSelectedPudoAddress, getKlarnaCustomerDetails],
  (pudoAddress, customerDetails) => {
    if (!pudoAddress) return;
    
    return {
      shipping_method: 'store pick-up',
      shipping_type: 'normal',
      first_name: customerDetails.firstName,
      last_name: customerDetails.lastName,
      street_address: `${pudoAddress.line1}, ${pudoAddress.line2}`,
      street_number: pudoAddress.buildingNameNumber,
      postal_code: pudoAddress.postcode,
      city: pudoAddress.line3,
      country: pudoAddress.countryCode,
    };
  },
);

export const getPudoAddressDetailsInAPIFormat = createSelector(
  [getSelectedPudoAddress],
  (pudoAddress) => {
    if (!pudoAddress) return;
    
    return {
      addressId: '',
      addressee: pudoAddress.name,
      companyName: pudoAddress.organisationName,
      houseNameNumber: pudoAddress.buildingNameNumber,
      streetName: pudoAddress.line1,
      addressLine2: pudoAddress.line2,
      town: pudoAddress.line3,
      county: pudoAddress.line4,
      postCode: pudoAddress.postcode,
      countryCode: pudoAddress.countryCode,
      residentId: '',
      contactNumber: pudoAddress.phoneNumber,
      clickAndCollectType: 'STORE',
    };
  },
);
